import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  tableRow: { width: '100%', display: 'flex', justifyContent: 'center' }
}))

export default useStyles
